export default "__VITE_ASSET__DgMYBuRb__"